
import { Options, Vue } from "vue-class-component";
import { menuModule, languagesModule } from "@/store";
import { LanguagesInterface, MenuChildInterface, MenuInterface } from "@/types";
import { useMq } from "vue3-mq";
import HeaderMenuItem from "./TheHeaderMenuItem/index.vue";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";

@Options({
  name: "HeaderMenu",
  components: { HeaderMenuItem, SvgIcon },
})
export default class HeaderMenu extends Vue {
  protected mq = useMq();

  protected get isLoading(): boolean {
    return menuModule.getGlobalLoader;
  }

  protected isRefTools(i: any): boolean {
    return i.name === "viewer";
  }

  private get activeLanguage(): LanguagesInterface {
    return languagesModule.getActiveLanguage;
  }

  private get menuData(): MenuInterface[] {
    const lang = this.activeLanguage; // { code, name }
    if (!lang?.code) {
      return menuModule.getMenu;
    }

    const TARGET_PARENT_NAMES = ["reviews", "articles"];
    const CODE_SLASH_PREFIX = `${lang.code}/`;

    const transformParent = (parent: MenuInterface): MenuInterface => {
      if (
        lang.code !== 'en' &&
        parent.name &&
        TARGET_PARENT_NAMES.includes(parent.name) &&
        parent.link &&
        !parent.link.startsWith(CODE_SLASH_PREFIX)
      ) {
        return {
          ...parent,
          link: `/${lang.code}${parent.link.trim()}`,
        };
      }
      return parent;
    };

    const transformChild = (ch: MenuChildInterface): MenuChildInterface => {
      if (!ch.link) return ch;

      let link = ch.link.trim();

      if (!link.startsWith(CODE_SLASH_PREFIX)) {
        link = `${lang.code}/${link}`;
      }

      return { ...ch, link };
    };

    return menuModule.getMenu.map((parent) => {
      if (lang.code == 'en') {
        return parent;
      }

      const adjustedParent = transformParent(parent);

      if (!adjustedParent.child) {
        return adjustedParent;
      }

      return {
        ...adjustedParent,
        child: adjustedParent.child.map(transformChild),
      };
    });
  }
}
